// @flow

import { type IncomingPayment } from '@tectonics/prs/incoming-payment';
import { type Receipt } from '@tectonics/prs/receipts';
import { egyptFinalReceiptStrategy } from '@tectonics/prs/egypt/final-receipt-adjustment';

type FinalReceiptStrategy = {
  shouldUse: (incomingPayment: IncomingPayment, receipt: Receipt) => boolean,
  execute: (incomingPayment: IncomingPayment, receipt: Receipt) => Receipt,
};

const strategies: Array<FinalReceiptStrategy> = [
  egyptFinalReceiptStrategy,
];

export function adjustFinalReceipt(incomingPayment: IncomingPayment, receipt: Receipt): Receipt {
  for (const strategy of strategies) {
    if (strategy.shouldUse(incomingPayment, receipt)) {
      return strategy.execute(incomingPayment, receipt);
    }
  }
  return receipt;
}
